module.exports = __webpack_public_path__ + "img/icon-sports.45257a38.png";